import React, { Component } from "react";
import './about.css'
import kofi from '../img/kofi_button_blue.png';

class About extends Component {
    render() {
        return(<div className="about">
            <h1>
                About
            </h1>
            <p>The Thread Palette Generator was created by Amanda Fox, a software engineer and embroidery artist who loves all things color! This tool was created with embroiderers in mind so you can easily create and save color palettes off of specific color codes.</p>
            <p>This tool is free for all, but if you feel inclined to help support the cost of hosting and database upkeep, I appreciate it!</p>
            <a href="https://ko-fi.com/crewelghoul" target="_blank"><img src={kofi} id="kofi"/></a>
        </div>)
    }
}

export default About;